export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/mhyiyyePdSMygDUd6hKoum/ChatGPT-Image-22-jul-2026_-07_09_31-p.m..webp'
export const PRODUCT_NAME = 'COACH FORCE PRO™'
export const CHECKOUT_URL = 'https://coach-force-pro.impultienda.ar/checkout'
